import loadScript from 'load-script';

const loadVirtualMirror = (sdkUrl)=>{
    return window.vmmv || new Promise((resolve, reject)=>loadScript(sdkUrl, (err)=>err ? reject(err) : resolve(window.vmmv)
        )
    );
};

export { loadVirtualMirror };
//# sourceMappingURL=load-vm.js.map
